import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import classnames from 'classnames';

import { GTM_ACTION, GTM_CLASS, GTM_CLASS_PREFIX } from '../../../lib/constant';
import { parseCategories } from '../../../utils/parseCategories';

import LeadFormModal from '../../modal/LeadFormModal/LeadFormModal';
import styles from './EndBanner.module.scss';

const EndBanner = (props) => {
  const { slug, categories, endBanner } = props;
  const [isShowPopup, setIsShowPopup] = useState(false);

  const categorySlug = parseCategories.getSlug(categories);

  const defaultBanner = (pageSlug) => (
    <Link
      href={`https://lifepal.co.id/promo/mobil-ldn/?slide=1&utm_campaign=LDN_${categorySlug}&utm_source=media&utm_medium=end_banner_img&utm_content=${pageSlug}`}
    >
      <a
        title="Lifepal banner widget"
        className={classnames(
          GTM_CLASS.REDIRECTION_IN_ARTICLE_CTA_BANNER,
          `${GTM_CLASS_PREFIX}${categorySlug}`,
        )}
      >
        <Image
          src="/media/static/images/LDN_AUT_CORET_13_EBI.jpeg"
          width="351px"
          height="271px"
          alt="Lifepal banner widget"
        />
      </a>
    </Link>
  );

  const ldnBanner = (banner) => {
    let targetLink = '';

    try {
      const href = new URL(banner.linkUrl);
      href.searchParams.set('utm_campaign', `LDN_${categorySlug}`);
      href.searchParams.set('utm_content', slug);
      targetLink = href.toString();
    } catch (err) {}

    if (banner.type === 'POPUP') {
      const popupDataLDN = {
        bannerMobileUrl: banner.imageMobileUrl,
        bannerDesktopUrl: banner.imageDesktopUrl,
        title: banner.leadFormTitle,
        category: banner.leadForm,
        category_value: banner.leadForm,
        useTimer: false,
        isOpen: true,
        gtmAction: GTM_ACTION.END_BANNER,
      };
      return (
        <>
          {isShowPopup && (
            <LeadFormModal popupData={popupDataLDN} closePopup={() => setIsShowPopup(false)} />
          )}
          <div
            onClick={() => setIsShowPopup(true)}
            className={classnames(
              GTM_CLASS.OPEN_LEADFORM_END_BANNER,
              `${GTM_CLASS_PREFIX}${banner.leadForm}`,
            )}
          >
            <img
              src={`${banner.imageDesktopUrl}`}
              width={`${banner.imageDesktopWidth}px`}
              height={`${banner.imageDesktopHeight}px`}
              alt="Lifepal Banner Widget"
            />
          </div>
        </>
      );
    } else {
      return (
        <Link href={targetLink}>
          <a
            title="Lifepal Banner Widget"
            className={classnames(
              GTM_CLASS.REDIRECTION_IN_ARTICLE_CTA_BANNER,
              `${GTM_CLASS_PREFIX}${categorySlug}`,
            )}
          >
            <img
              src={`${banner.imageDesktopUrl}`}
              width={`${banner.imageDesktopWidth}px`}
              height={`${banner.imageDesktopHeight}px`}
              alt="Lifepal Banner Widget"
            />
          </a>
        </Link>
      );
    }
  };

  return (
    <div className={styles.endBanner}>
      {endBanner && endBanner.type ? ldnBanner(endBanner) : defaultBanner(slug)}
    </div>
  );
};

export default EndBanner;
